<template>
  <!-- <a>, nao <div> com handler: o alvo e um site externo, entao clique do
       meio, "abrir em nova aba" e o preview do link no rodape do browser
       passam a funcionar de graca. rel="noopener" e obrigatorio junto de
       target="_blank". -->
  <a
    :href="card.link"
    target="_blank"
    rel="noopener noreferrer"
    class="qtx-link"
    @click="$emit('learn-more', card)"
  >
    <span class="qtx-link-title">{{ card.title }}</span>
    <span class="qtx-link-more">
      <span class="qtx-more-label">{{ $t("landingCard.learnMore") }}</span>
      <span class="qtx-icon">
        <svg viewBox="0 0 26 26"><path d="M.627 3.212L4.14.401l10.124 12.655L4.141 25.712.627 22.901l7.875-9.845L.627 3.212zm19.125 9.844l-7.875-9.844L15.39.401l10.124 12.655-10.124 12.656-3.514-2.811 7.875-9.845z"></path></svg>
      </span>
    </span>
  </a>
</template>

<script>
export default {
  // O clique so e ANUNCIADO daqui - quem avisa o servidor e a view, que e quem
  // conhece os tres cards. `@click` cobre o clique comum e o ctrl/cmd+clique
  // (que abre em nova aba e dispara `click` do mesmo jeito); o clique do meio
  // dispara `auxclick`, nao `click`, e nao e rastreado de proposito - o alvo do
  // rastro e quem foi ler sobre o produto, e para isso a amostra do clique
  // comum basta.
  props: ["card"],
};
</script>

<style scoped>
/* Linha, nao cartao: no painel de login os tres produtos sao um rodape de
   navegacao. A descricao continua no i18n (landing.*.description) para quem
   quiser reabrir o formato de cartao. */
.qtx-link {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.85rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  text-decoration: none;
  color: #c7c9ce;
  transition: color 0.2s ease;
}
.qtx-link:last-child {
  border-bottom: none;
}
.qtx-link:hover {
  color: #fff;
}
.qtx-link-title {
  font-size: 0.9rem;
  font-weight: 500;
}
.qtx-link-more {
  flex: 0 0 auto;
  font-size: 0.75rem;
  font-weight: 500;
  color: #ffbf00;
  white-space: nowrap;
}
.qtx-icon {
  display: inline-block;
  margin-left: 6px;
  font-size: 7px;
  vertical-align: baseline;
}
.qtx-icon svg {
  display: block;
  fill: currentcolor;
  height: 1em;
  width: 1em;
}

/* No celular estreito o rotulo "Saiba mais" nao cabe ao lado do titulo: o mais
   longo dos tres ("Distribua em multiplos canais...") ja pede a linha inteira a
   375px, e a linha inteira e o que ele ganha aqui - sobra a seta, que e a
   affordance, e o alvo de toque continua sendo a linha toda porque quem e o
   <a> e a linha, nao o rotulo.
   A seta cresce porque sozinha ela precisa se ler; e o alinhamento passa a ser
   pelo centro, ja que sem texto ao lado nao ha mais linha de base comum. */
@media (max-width: 480px) {
  .qtx-link {
    align-items: center;
    gap: 0.75rem;
  }
  .qtx-more-label {
    display: none;
  }
  .qtx-icon {
    margin-left: 0;
    font-size: 10px;
  }
}
</style>
